/*
 * Behaviour for the ported blocks. The source site drives these with jQuery,
 * Owl Carousel, mCustomScrollbar and intl-tel-input; this is a dependency-free
 * equivalent with the same observable behaviour.
 */
(function () {
  "use strict";

  /* ---------------------------------------------------------- carousel --- */

  function initCarousel(root) {
    var track = root.querySelector("[data-carousel-track]");
    var slides = root.querySelectorAll(".carousel__slide");
    var prev = root.querySelector("[data-carousel-prev]");
    var next = root.querySelector("[data-carousel-next]");
    var dots = root.querySelectorAll("[data-carousel-dot]");
    if (!track || !slides.length) return;

    // One slide at every width, matching the source's rendered block.
    var index = 0;
    var maxIndex = slides.length - 1;

    function apply() {
      track.style.transform = "translateX(-" + index * 100 + "%)";
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex;
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    if (prev) prev.addEventListener("click", function () {
      index = Math.max(0, index - 1);
      apply();
    });
    if (next) next.addEventListener("click", function () {
      index = Math.min(maxIndex, index + 1);
      apply();
    });
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener("click", function () {
        index = i;
        apply();
      });
    });

    apply();
  }

  /* ------------------------------------------------------- video modal --- */

  var openModal = null;

  function closeModal() {
    if (!openModal) return;
    openModal.remove();
    openModal = null;
    document.removeEventListener("keydown", onModalKey);
  }

  function onModalKey(e) {
    if (e.key === "Escape") closeModal();
  }

  function initVideoOpeners(root) {
    root.querySelectorAll("[data-video-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-youtube-id");
        if (!id) return;

        closeModal();
        var modal = document.createElement("div");
        modal.className = "modal";
        modal.setAttribute("role", "dialog");
        modal.setAttribute("aria-modal", "true");
        modal.setAttribute("aria-label", btn.getAttribute("aria-label") || "Video");

        var inner = document.createElement("div");
        inner.className = "modal__inner";

        var close = document.createElement("button");
        close.className = "modal__close";
        close.type = "button";
        close.setAttribute("aria-label", "Close video");
        close.innerHTML = "&times;";
        close.addEventListener("click", closeModal);

        var frame = document.createElement("iframe");
        frame.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
        frame.title = btn.getAttribute("aria-label") || "Video";
        frame.allow = "accelerometer; autoplay; encrypted-media; picture-in-picture";
        frame.allowFullscreen = true;

        inner.appendChild(close);
        inner.appendChild(frame);
        modal.appendChild(inner);
        modal.addEventListener("click", function (e) {
          if (e.target === modal) closeModal();
        });

        document.body.appendChild(modal);
        openModal = modal;
        close.focus();
        document.addEventListener("keydown", onModalKey);
      });
    });
  }

  /* --------------------------------------------------------- countries --- */

  /** Parse "Name|+dial|iso" lines into objects, dropping repeats. */
  function parseCountries(raw) {
    if (!raw) return [];
    var seen = {};
    return raw
      .split("\n")
      .map(function (line) {
        var parts = line.split("|");
        if (parts.length < 2) return null;
        return {
          name: (parts[0] || "").trim(),
          dial: (parts[1] || "").trim(),
          iso: (parts[2] || "").trim().toLowerCase(),
        };
      })
      .filter(function (c) {
        if (!c || !c.name || !c.dial) return false;
        // intl-tel-input pins US and GB at the top and repeats them in the
        // alphabetical list; keep the first occurrence only.
        var key = (c.iso || c.name) + "|" + c.dial;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function initPhoneField(field) {
    var countries = parseCountries(field.getAttribute("data-countries"));
    if (!countries.length) countries = [{ name: "United States", dial: "+1", iso: "us" }];

    var toggle = field.querySelector("[data-phone-toggle]");
    var flagOut = field.querySelector("[data-phone-flag]");

    /** Swap the sprite class, e.g. iti__flag iti__ie. */
    function setFlag(iso) {
      if (!flagOut) return;
      flagOut.className = "iti__flag iti__" + String(iso || "us").toLowerCase();
    }
    var list = field.querySelector("[data-phone-list]");
    var search = field.querySelector("[data-phone-search]");
    var options = field.querySelector("[data-phone-options]");
    if (!toggle || !list || !options) return;

    var selected = countries[0];
    setFlag(selected.iso);

    function render(filter) {
      var q = (filter || "").trim().toLowerCase();
      var shown = q
        ? countries.filter(function (c) {
            return c.name.toLowerCase().indexOf(q) !== -1 || c.dial.indexOf(q) !== -1;
          })
        : countries;

      options.innerHTML = "";
      if (!shown.length) {
        var empty = document.createElement("li");
        empty.className = "iti-list__empty";
        empty.textContent = "No matches";
        options.appendChild(empty);
        return;
      }

      shown.forEach(function (c) {
        var li = document.createElement("li");
        var btn = document.createElement("button");
        btn.type = "button";
        btn.setAttribute("role", "option");
        btn.setAttribute("aria-selected", c.name === selected.name ? "true" : "false");

        var flag = document.createElement("span");
        flag.className = "iti__flag iti__" + String(c.iso || "us").toLowerCase();

        var name = document.createElement("span");
        name.className = "iti-list__name";
        name.textContent = c.name;

        var dial = document.createElement("span");
        dial.className = "iti-list__dial";
        dial.textContent = c.dial;

        btn.appendChild(flag);
        btn.appendChild(name);
        btn.appendChild(dial);
        btn.addEventListener("click", function () {
          selected = c;
          setFlag(c.iso);
          setOpen(false);
          if (search) search.value = "";
        });

        li.appendChild(btn);
        options.appendChild(li);
      });
    }

    function setOpen(open) {
      list.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        render(search ? search.value : "");
        if (search) search.focus();
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(list.hidden);
    });
    if (search) {
      search.addEventListener("input", function () {
        render(search.value);
      });
    }
    document.addEventListener("mousedown", function (e) {
      if (!list.hidden && !field.contains(e.target)) setOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !list.hidden) setOpen(false);
    });

    render("");
    return countries;
  }

  function fillSelect(select, values, keepFirst) {
    if (!select) return;
    values.forEach(function (v) {
      var opt = document.createElement("option");
      opt.textContent = v;
      select.appendChild(opt);
    });
    if (!keepFirst) return;
  }

  /* -------------------------------------------------------------- init --- */

  /* --------------------------------------------------------- wordmark --- */

  /*
   * The pinned wordmark shrinks to a third once the hero has passed: measured
   * 154.656px down to 51.552px on the source, switching between scroll 900 and
   * 1000, which is the hero's own height. CSS carries the 0.3s transition.
   */
  /*
   * Port of the source's own watchScroll. One handler drives two things off the
   * same threshold, which is the viewport height, not the hero's:
   *
   *   - the footer nav slides in and fades up, at every width
   *   - the wordmark shrinks, but ONLY from 1024px up. On a phone the source
   *     leaves it at full size; ours used to shrink it to a third there.
   *
   * The source writes the three shrink values inline; the .is-small rule in the
   * stylesheet carries the same numbers, so the class does the work here.
   */
  function initWordmark() {
    var mark = document.querySelector(".hero__wordmark");
    var footerNav = document.querySelector(".footer__nav");
    if (!mark && !footerNav) return;

    var isDesktop = window.innerWidth >= 1024;
    var ticking = false;

    function apply() {
      var shrink = window.scrollY > window.innerHeight;
      if (footerNav) footerNav.classList.toggle("is-active", shrink);
      if (mark) mark.classList.toggle("is-small", isDesktop && shrink);
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });

    window.addEventListener("resize", function () {
      isDesktop = window.innerWidth >= 1024;
      apply();
    });

    apply();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initWordmark();

    document.querySelectorAll("[data-video-carousel]").forEach(function (root) {
      initCarousel(root);
      initVideoOpeners(root);
    });

    var countries = [];
    document.querySelectorAll("[data-phone-field]").forEach(function (field) {
      countries = initPhoneField(field) || [];
    });

    /*
     * Each select carries its own captured option list in data-options.
     *
     * The country select is NOT the phone list: intl-tel-input names countries
     * informally with native spellings, while the select uses formal ISO names
     * ("Bonaire, Sint Eustatius and Saba"). Filling it from the phone list put
     * 147 entries in it that the original does not have.
     */
    function fillFromData(select) {
      if (!select) return;
      var raw = select.getAttribute("data-options") || "";
      var values = raw.split("\n").map(function (s) { return s.trim(); }).filter(Boolean);
      if (values.length) fillSelect(select, values);
    }

    fillFromData(document.querySelector("[data-country-select]"));
    fillFromData(document.querySelector("[data-month-select]"));
    fillFromData(document.querySelector("[data-day-select]"));

    /*
     * Hero video. Measured on the live store (b1412t-ck, 24 Sep 2026): the
     * muted autoplay video loaded (readyState 3) and stayed paused at 0:00,
     * while the same file autoplayed on a bare page and play() here resolved
     * without error. So the visible one is started by hand; the hidden
     * breakpoint copy is left alone so it does not download for nothing.
     */
    document.querySelectorAll("video.video-image[autoplay]").forEach(function (video) {
      if (!video.offsetWidth || !video.paused) return;
      video.muted = true;
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    });

    // Study clone: the form never submits.
    document.querySelectorAll("[data-inert-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var note = form.querySelector("[data-form-note]");
        if (note) note.textContent = "Clone is inert: nothing was submitted or stored.";
      });
    });
  });
})();
